import styled from 'styled-components/native';

import Icon from '@components/Icon';
import Text from '@components/Text';

export const Container = styled.View``;

export const ButtonText = styled(Text)`
  color: ${props => props.theme.colors.interaction.slot1};
  font-family: ${props => props.theme.fonts.weight[700]};
  font-size: 12px;
`;

export const ReloadButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

export const ReloadText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot6};
  font-family: ${props => props.theme.fonts.weight[400]};
  font-size: 12px;
  margin-bottom: 18px;
`;

export const ReloadIcon = styled(Icon)`
  color: ${props => props.theme.colors.interaction.slot1};
  transform: rotateY(0deg) rotate(-90deg);
  margin-right: 13px;
`;
